import { render, staticRenderFns } from "./case-details.vue?vue&type=template&id=40ba05fa&scoped=true"
import script from "./case-details.vue?vue&type=script&lang=js"
export * from "./case-details.vue?vue&type=script&lang=js"
import style0 from "./case-details.vue?vue&type=style&index=0&id=40ba05fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ba05fa",
  null
  
)

export default component.exports